import { render, staticRenderFns } from "./BusinessPortalAccess.vue?vue&type=template&id=68d9c1f6&scoped=true"
import script from "./BusinessPortalAccess.vue?vue&type=script&lang=js"
export * from "./BusinessPortalAccess.vue?vue&type=script&lang=js"
import style0 from "./BusinessPortalAccess.vue?vue&type=style&index=0&id=68d9c1f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d9c1f6",
  null
  
)

export default component.exports